
define('ldsh!modules/editor/templates/navigation_tabs', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<input class="trigger" type="checkbox" id="mainNavButton">\n<label for="mainNavButton" class="i18n" data-i18n="landingPage.tabs"></label>\n<div class="navigation_tabs_container"></div>\n';

}
return __p
};});

